import { Component } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ErrorMessage } from '@northfork/ng-basics'

@Component({
  selector: 'app-force-recon-ts',
  templateUrl: './force-recon-ts-warning.component.html',
})
export class ForceReconTsWarningComponent {
  justification = new FormControl('', [
    Validators.required,
    this.wordCountValidator.bind(this),
  ])

  constructor(public activeModal: NgbActiveModal) {}

  wordCountValidator(control: FormControl): { [key: string]: boolean } | null {
    const value = (control.value || '').trim()
    const wordCount = value.split(/\s+/).filter((n: string) => n).length
    const charCount = value.length
    const errors: { [key: string]: boolean } = {}

    if (wordCount < 3) {
      errors['lessWordCount'] = true
    }
    if (charCount > 200) {
      errors['overCharCount'] = true
    }
    return Object.keys(errors).length ? errors : null
  }

  customErrorMessages: ErrorMessage[] = [
    {
      error: 'required',
      format: () => 'Justification is required.',
    },
    {
      error: 'lessWordCount',
      format: () => 'Must be at least 3 words.',
    },
    {
      error: 'overCharCount',
      format: () => 'Cannot exceed 200 characters.',
    },
  ]
}
